import CustomModal from '../..';
import "./styles.css";
import "./mobile.css";
import ConfirmContactMethodsModalWorkflow from 'components/workflows/ConfirmContactMethodsModalWorkflow';
import AddPhoneContactMethodModalWorkflow from 'components/workflows/AddPhoneContactMethodModalWorkflow';
import AddEmailContactMethodModalWorkflow from 'components/workflows/AddEmailContactMethodModalWorkflow';

export default function AddContactMethodModal(props) {
    return (
        <CustomModal id="AddContactMethodModal" className="add-contact-method-modal">
          { props.data.workflowType === "addPhoneWorkflow" &&
            <AddPhoneContactMethodModalWorkflow { ...props.data } />
          }
          { props.data.workflowType === "addEmailWorkflow" &&
            <AddEmailContactMethodModalWorkflow { ...props.data } />
          }
          { props.data.workflowType === "confirmNowWorkflow" &&
            <ConfirmContactMethodsModalWorkflow { ...props.data } />
          }
        </CustomModal>
    )
}
